import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Formik, Form } from 'formik';
import { isEqual } from 'lodash';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { searchActions } from '../../../store/searchStore';
import { withLocalize, Translate } from 'react-localize-redux';
import { withRouter } from "react-router";
import BbDatePicker from "../../common/datePicker";
import BbInput from "../../styling/bbInput";
import classnames from 'classnames'
import moment from 'moment';
import SearchTip from '../../common/searchTip';

import '../../../css/search/search.scss';

class LiensSearchForm extends React.Component {
    state = { showWarning: false }

    initialValues = {
        fileNumber: '',
        companyId: "",
        businessName: "",
        subjectType: '',
        vin: '',
        dateFrom: '',
        dateTo: '',
        page: 1,
        pageSize: 1
    };

    changeWarning(show) {
        this.setState({ showWarning: show });
    }

    render() {
        return (
            <div className="content-root-narrow">
                <Formik
                    ref={(el) => this.formRef = el}
                    initialValues={this.initialValues}
                    onSubmit={(values, { setSubmitting }) => { setSubmitting(false); this.submitSearch(values) }}
                >
                    {({ values, }) => (
                        <Form>
                            <SearchTip windowId={`tips_liens`} getSearchTipsModel={this.getSearchTipsModel} style={{ marginBottom: '-0.5em', marginTop: '1em' }} />
                            <div className='card card-special' style={{ paddingTop: "1.5em" }}>
                                <div className='card-body'>
                                    <BbInput type="text" name="fileNumber" label={this.props.translate('Search.Liens.SearchForm.FileNumber')}
                                        placeholder={{ type: 'column' }} />
                                    <div className='field bb-field'>
                                        <div className="columns">
                                            <div className="column is-4 bb-input-label-column">
                                                <div className="bankruptcy-label">
                                                    <Translate id="Search.Liens.SearchForm.Created" />
                                                </div>
                                            </div>
                                            <div className="column is-4">
                                                <div className="bankruptcy-date">
                                                    <BbDatePicker
                                                        formik={this.formRef}
                                                        placeholder={this.props.translate("Report.Common.From")}
                                                        field={'dateFrom'}
                                                        value={values.dateFrom}
                                                        formDateFormat={"YYYY-MM-DD"}
                                                        yearsBack={120} />
                                                </div>
                                            </div>
                                            <div className="column is-4">
                                                <div className="bankruptcy-date">
                                                    <BbDatePicker
                                                        formik={this.formRef}
                                                        field={'dateTo'}
                                                        value={values.dateTo}
                                                        placeholder={this.props.translate("Report.Common.To")}
                                                        formDateFormat={"YYYY-MM-DD"}
                                                        yearsBack={120}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <BbInput type="text" name="vin" label={this.props.translate('Search.Liens.SearchForm.VIN')} placeholder={{ type: 'column' }}
                                    />
                                    <BbInput type="text" name="businessName" label={this.props.translate('Search.Liens.SearchForm.BusinessName')}
                                        placeholder={{ type: 'column' }} />
                                    <BbInput type="text" name="companyId" label={this.props.translate('Search.Liens.SearchForm.CompanyId')}
                                        placeholder={{ type: 'column' }} />
                                    <div className='has-text-centered' style={{ padding: "0.5em 0 1.5em" }}>
                                        {this.state.showWarning && <div className="column is-narrow" >
                                            <b><Translate id='Search.Bankruptcy.SearchForm.WarningFillIn' /></b>
                                        </div>}
                                        <div className='column is-narrow'>
                                            <button className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} style={{ fontWeight: 600 }} type="submit" disabled={this.props.isSearching}>
                                                <Translate id="Search.Common.Search" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        )
    }

    submitSearch(values) {
        if (isEqual(values, this.initialValues)) {
            this.changeWarning(true);
            return;
        }
        this.changeWarning(false);
        var fd = this.getSearchFormData(values);
        this.props.history.push({ pathname: `${this.props.path}/results`, state: fd });
    }

    getSearchFormData(values) {
        return {
            ...values,
            companyId: values.companyId.replace(/\s/g, ''),
            dateFrom: isNullOrUndefined(values.dateFrom) || values.dateFrom === "" ? null : moment(values.dateFrom).format("YYYY-MM-DD"),
            dateTo: isNullOrUndefined(values.dateTo) || values.dateTo === "" ? null : moment(values.dateTo).format("YYYY-MM-DD")
        };
    }

    getSearchTipsModel = () => {
        return { title: `${this.props.translate('Search.Liens.SectionName')}`, bodyHtml: this.props.translate('SearchTips.Liens.Body') };
    }
}

export default withRouter(withLocalize(connect(
    state => ({ ...state, search: state.search }),
    dispatch => bindActionCreators({ ...searchActions }, dispatch),
)(LiensSearchForm)));